import { addItemToCollection } from "directus/src/operations";

export async function createJob({ item }) {
  try {
    const query = {
      fields: [
        "id",
        "name",
        "coordinator",
        "project.project_id",
        "description",
        "project",
        "contract.id",
        "contract.name",
        "type",
      ],
    };

    const data = await addItemToCollection("jobs", item, query);

    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
